import appStore from 'store';
import api from './api';
import { RECORD_STATUS } from './constants';
const store = {
  namespaced: true,
  state: {
    coinTypes: [],
    records: [],
    totalCount: 0,
    activeTab: '',
    pagination: {
      page: 1,
      size: 25
    }
  },
  getters: {
    records: state =>
      state.records.map(item => ({
        ...item,
        __status: RECORD_STATUS[item.status]
      }))
  },
  mutations: {
    setCoinTypes(state, payload) {
      state.coinTypes = payload;
    },
    setRecords(state, payload) {
      state.records = payload.list.concat();
      state.totalCount = payload.totalCount;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    changeTab(state, payload) {
      state.activeTab = payload;
    }
  },
  actions: {
    getCoinTypes({ commit }) {
      api.getCoinTypes().then(({ data }) => {
        commit('setCoinTypes', data);
      });
    },
    getRecords({ commit }, query) {
      api.getRecords(query).then(({ data }) => {
        commit('setRecords', data);
        commit('setPagination', { size: query.size, page: query.page });
      });
    },
    createRecord(context, data) {
      return new Promise(resolve => {
        api.createRecord(data).then(res => {
          resolve(res);
        });
      });
    }
  }
};

appStore.registerModule('txRecord', store);
